import { render, staticRenderFns } from "./AddSale.vue?vue&type=template&id=2c86e6ea&scoped=true&"
import script from "./AddSale.vue?vue&type=script&lang=js&"
export * from "./AddSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86e6ea",
  null
  
)

export default component.exports